/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_HardenInputs */

const en_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const ar_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تقوية`)
};

const bn_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const de_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const es_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const fr_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const pt_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const zh_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const tr_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const ru_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

const pl_svtag_harden = /** @type {(inputs: Svtag_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#HARDEN`)
};

/**
* | output |
* | --- |
* | "#HARDEN" |
*
* @param {Svtag_HardenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_harden = /** @type {((inputs?: Svtag_HardenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_HardenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_harden(inputs)
	if (locale === "bn") return bn_svtag_harden(inputs)
	if (locale === "de") return de_svtag_harden(inputs)
	if (locale === "es") return es_svtag_harden(inputs)
	if (locale === "fr") return fr_svtag_harden(inputs)
	if (locale === "pt") return pt_svtag_harden(inputs)
	if (locale === "zh") return zh_svtag_harden(inputs)
	if (locale === "tr") return tr_svtag_harden(inputs)
	if (locale === "ru") return ru_svtag_harden(inputs)
	if (locale === "pl") return pl_svtag_harden(inputs)
	return en_svtag_harden(inputs)
});